<div class="as-lang-group">
  <div class="as-lang-box" *ngFor="let l of languages" (click)="onLanguageSelect(l)">
    <div class="as-lang-small-box">
      <div class="as-lang-text">{{ l }}</div>
    </div>
    <div class="as-sect-block" *ngIf="l.toUpperCase() === lang"></div>
    <div class="as-sect-block-null" *ngIf="l.toUpperCase() !== lang"></div>
  </div>
</div>
